export default __webpack_public_path__ + "static/media/golf.389071b5.svg";